import React from 'react';

/**
 * Catches render-time errors anywhere below it and shows a recoverable fallback
 * instead of a blank white screen. Without this, a single throw (a malformed
 * product, a null deref, a context used outside its provider) takes down the
 * entire site. Uses inline styles so the fallback renders even if the CSS/theme
 * failed to load.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Hook for a monitoring service (e.g. Sentry) once one is configured.
    // eslint-disable-next-line no-console
    console.error('Unhandled UI error:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.assign('/');
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            fontFamily: 'sans-serif',
            textAlign: 'center',
          }}
        >
          <div>
            <h1 style={{ fontSize: '1.875rem', fontWeight: 800, letterSpacing: '-0.03em', marginBottom: '0.75rem', color: '#111827' }}>
              Es ist ein Fehler aufgetreten
            </h1>
            <p style={{ color: '#6b7280', marginBottom: '1.5rem', maxWidth: '28rem' }}>
              Bitte laden Sie die Seite neu. Falls das Problem weiterhin besteht, kontaktieren Sie uns bitte.
            </p>
            <button
              onClick={this.handleReload}
              style={{
                backgroundColor: 'rgb(var(--brand))',
                color: '#fff',
                border: 'none',
                padding: '0.875rem 2rem',
                borderRadius: '9999px',
                fontWeight: 600,
                fontSize: '0.875rem',
                cursor: 'pointer',
                boxShadow: '0 12px 28px -12px rgb(var(--brand)/0.45)',
              }}
            >
              Zur Startseite
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
